import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapLegendStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    chartLegendsFontColor: {
      fontSize: '0.85em',
    },
    accordion: {
      width: '100%',
    },
    accordionSummary: { display: 'flex', alignItems: 'center' },
    menu: {
      minWidth: 300,
    },
    menuHeader: {
      paddingLeft: spacing(),
      width: 300,
    },
    menuPaper: {
      maxHeight: 'calc(100% - 100px)',
      padding: spacing(),
    },
    header: {
      height: 50,
      width: 300,
      padding: `${spacing(6)} ${spacing(4)} 0`,
    },
    listItem: {
      width: 300,
      padding: `${spacing(2)} ${spacing(4)} 0 ${spacing(1)}`,
    },
    listItemLabel: {
      lineHeight: '1.3em',
      paddingLeft: spacing(),
    },
    listItemCount: {
      lineHeight: '1.3em',
      paddingLeft: spacing(),
      textAlign: 'right',
    },
    roundIcon: { borderRadius: 25 },
    statusIcon: {
      width: 14,
      height: 14,
    },
    legendIcon: {
      filter: palette.mode === 'dark' ? 'brightness(0) invert(1)' : undefined,
    },
    pieChartHeader: {
      padding: `${spacing()} ${spacing(2)}`,
    },
    button: {
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
    statusGrid: {
      display: 'flex',
      alignItems: 'center',
    },
  });
});

export default useMapLegendStyles;
